import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import CreateDashboardModal from 'components/DashboardAddForm/CreateDashboardModal';
import { DashboardT } from 'business/definitions';
import { Box } from '@mui/material';

type DashboardAddFormProps = {
    onCreate?: (arg1: DashboardT) => void;
};

function DumbDashboardAdd(props: DashboardAddFormProps): React.ReactElement {
    const [openCreation, setOpenCreation] = React.useState(false);
    const { t } = useTranslation();
    const { onCreate } = props;
    return (
        <Box sx={{ mt: '1rem' }}>
            <CreateDashboardModal
                isOpen={openCreation}
                onCreate={onCreate}
                onClose={() => setOpenCreation(false)}
            />
            <Button
                onClick={() => setOpenCreation(true)}
                variant="contained"
                sx={{ mb: '8px' }}
                className="e2e-library-new-dashboard"
                data-testid="create-dashboard-button"
            >
                {t('home.createDashboard')}
            </Button>
        </Box>
    );
}

export default DumbDashboardAdd;
